// eslint-disable-next-line import/prefer-default-export
export var EntityTypePrefix;
(function (EntityTypePrefix) {
    EntityTypePrefix["Inspection"] = "Inspection";
    EntityTypePrefix["Visit"] = "Visit";
    EntityTypePrefix["Work_order"] = "WorkOrder";
    EntityTypePrefix["Generic_event"] = "GenericEvent";
})(EntityTypePrefix || (EntityTypePrefix = {}));
// eslint-disable-next-line camelcase
export var GenericEventType;
(function (GenericEventType) {
    GenericEventType["On_call"] = "on_call";
    GenericEventType["Training"] = "training";
    GenericEventType["Site_visit"] = "site_visit";
})(GenericEventType || (GenericEventType = {}));
export const GenericEventIcon = {
    [GenericEventType.On_call]: 'fa-light fa-mobile-signal',
    [GenericEventType.Training]: 'fa-light fa-user-helmet-safety',
    [GenericEventType.Site_visit]: 'fa-light fa-location-dot'
};
// eslint-disable-next-line camelcase
export var CalendarEventType;
(function (CalendarEventType) {
    CalendarEventType["Generic_event"] = "genericEvent";
    CalendarEventType["Visit"] = "visit";
    CalendarEventType["Timeoff"] = "timeoff";
    CalendarEventType["Holiday"] = "holiday";
})(CalendarEventType || (CalendarEventType = {}));
